import { getAction, postAction } from "./manage"


export async function signup(data) {

}

export async function login(param) {
  return postAction("/app/auth/kakaoAuthLogin/" + param)
}

export function getUserInfo() {
  return getAction('/user-management/my-information')
}
